
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeItemsBOMGrid extends Serenity.EntityGrid<ExchangeItemsBOMRow, any> {
        protected getColumnsKey() { return 'Retail.ExchangeItemsBOM'; }
        protected getDialogType() { return ExchangeItemsBOMDialog; }
        protected getIdProperty() { return ExchangeItemsBOMRow.idProperty; }
        protected getInsertPermission() { return ExchangeItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeItemsBOMRow.localTextPrefix; }
        protected getService() { return ExchangeItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}